import {request} from "@/network/request";

export function getsearch(input){
    return request({
        url:'/api/show_search/'+input
    })}

export function getrnaother(input){
    return request({
        url:'/api/show_rnaother/'+input
    })}

export function getrnainter(input){
    return request({
        url:'/api/show_inter/'+input
    })}

export function search(form){
    return request({
        url:'/api/show_complex_search/',
        params:form
    })}

export function blast(bform){
    return request({
        url:'/api/show_blast/',
        params:bform
    })}

export function blastsec(bform){
    return request({
        url:'/api/show_blastsec/',
        params:bform
    })}